import { render, staticRenderFns } from "./lstRole.vue?vue&type=template&id=3bcc82de&"
import script from "./lstRole.vue?vue&type=script&lang=js&"
export * from "./lstRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports